import { render, staticRenderFns } from "./Requirement.vue?vue&type=template&id=51c0e2ac&scoped=true&"
import script from "./Requirement.vue?vue&type=script&lang=js&"
export * from "./Requirement.vue?vue&type=script&lang=js&"
import style0 from "./Requirement.vue?vue&type=style&index=0&id=51c0e2ac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0e2ac",
  null
  
)

export default component.exports